export default "__VITE_ASSET__4cfcc3d9__"